module.exports = "/_next/static/images/cc6475ab3c0fff47d5e71bc56d8da8fa-card-lock-new.svg.webp";